import React, { useEffect, useState } from 'react';
import * as api from '../../../api'
import { Link } from 'react-router-dom';
import { exportCSVFDCandidats, exportCSVFDJurys } from '../CSVExporter';
import FDCategories from './FDCategories';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';

const RatingLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid #ccc;

    > .projinfo {
        width: 40%;

        > span{
            cursor: pointer;
            &:hover{
                color: blue;
            }
        }

        > select {
            transform: translateX(-15px);
        }
    }
`

const ColorBlock = styled.div`
    width: 50px;
    height: 30px;
    border-radius: 5px;
`

const TableHeader = styled.div`
    margin-left: 45%;
    height: 100px;
    position: relative;

    > span {
        position: absolute;
        transform: rotate(-45deg);
        transform-origin: 0;
        bottom:0;
        left: 0;
    }
`

const CompilationLine = ({project,ratings,updateProjetStatusFinal,updateProjetCategorie}) => {
    let color = "lightgrey"
    if(project.projet.statusFinal === "validé"){
        color = "green"
    }
    if(project.projet.statusFinal === "refusé"){
        color = "red"
    }

    function totalMentionsForProj(_ratings){
        return _ratings.reduce((total,rating) => total + ((rating.rating.Innovation_durabilité === "checked" ? 1 : 0) + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0) + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0)),0)
    }

    // //make the string lowercase, and the first letter uppercase
    // function quentinCase(string){
    //     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    // }

    //make the string lowercase, and the first letter of each word uppercase
    function quentinCase(string){
        return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    }

    return (
        <RatingLine>
            <div className='projinfo'>
                <span onClick={()=>window.open("/fdfichev2?email="+project.user.user.email+"&pid="+project.user.participation._id,"_blank")} >{project.user.hsProfile.company.toUpperCase()}</span><br/>
                <span onClick={()=>window.open("/fdfichev2?email="+project.user.user.email+"&pid="+project.user.participation._id+"&projid="+project.projet._id,"_blank")} className='thin'>{quentinCase(project.projet.title)}</span><br/>
                <select value={project.projet.categorie} onChange={(e)=>{updateProjetCategorie(project.projet.participationId,project.projet._id,e.target.value)}}>
                    <option value="">Catégorie</option>
                    {FDCategories.map((cat,i) => 
                        <option value={cat} key={i}>{cat}</option>
                    )}
                </select>
            </div>
            <span>{ratings.reduce((totalStars,rating) => totalStars + rating.rating.stars || 0,0)}</span>
            <span>{ratings.reduce((total,rating) => total + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0),0)}</span>
            <span>{ratings.reduce((total,rating) => total + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0),0)}</span>
            <span>{ratings.reduce((total,rating) => total + (rating.rating.Innovation_durabilité === "checked" ? 1 : 0),0)}</span>
            <span>{totalMentionsForProj(ratings)}</span>
            <select value={project.projet.statusFinal} onChange={(e)=>{updateProjetStatusFinal(project.projet.participationId,project.projet._id,e.target.value)}}>
                <option value="">À valider</option>
                <option value="validé">Validé</option>
                <option value="refusé">Refusé</option>
            </select>
            <ColorBlock style={{backgroundColor:color}}/>
        </RatingLine>
    )
}
  
const FDCompilationJury = () => {

    const [event, setEvent] = useState(null);
    const [allParticipations, setAllParticipations] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [ratings, setRatings] = useState([]);
    const [allJuries, setAllJuries] = useState([]);
    const [tri, setTri] = useState('note_et_mention');
    const [filtre, setFiltre] = useState('');

    //parse eid from url
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "FD 100";
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
    }, [event])
    function getAllParticipations(){
        // Use dedicated FD100 3rd edition endpoint that includes all participations even with missing user/hs data
        api.getFD100ThirdEditionWinners().then((response) => {
            console.log("response.data de get FD100 3rd edition winners");
            console.log(response.data);
            setAllParticipations(response.data);
            let _allProjetcs = []
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    let projCount = 0;
                    user.participation.data.projets.forEach(project => {
                        // Project data is stored as objects in participation.data.projets for this event
                        if(typeof project === 'object' && project !== null && project.status === "validé"){
                            _allProjetcs.push({ projet: { ...project, participationId: user.participation._id }, user: user })
                            projCount++;
                        }
                    })
                    // debug pour vérifier qu'il n'y a pas plus d'un projet validé par participation
                    // if(projCount > 1){
                    //     alert("plus d'un projet validé pour la participation : "+user.hsProfile.company);
                    // }
                    // else{
                    //     console.log("un seul ou zéro projet validé pour la participation : "+user.hsProfile.company);
                    // }
                }
            })
            console.log("_allProjetcs");
            console.log(_allProjetcs);
            setAllProjects(_allProjetcs)
        }).catch((error) => {
            console.log(error);
        });
    }

    //get all jury's ratings
    useEffect(() => {
        if (!event) return;
        api.getAllJuriesForEvent({ eventId: event._id }).then((response) => {
            console.log("response.data de get all juries");
            console.log(response.data);
            let _allJuries = response.data.sort((a,b) => a.last_name.localeCompare(b.last_name));
            setAllJuries(_allJuries);
            let _ratings = [];
            _allJuries.forEach(jury => {
                if (jury.juryNotes) {
                    jury.juryNotes.forEach(rating => {
                        rating.jury = jury
                        let _projetIndex = _ratings.findIndex(r => r.id === rating.participationId + rating.projetId)
                        if (_projetIndex === -1) {
                            _ratings.push({id : rating.participationId + rating.projetId, ratings : [{rating}]})
                        } else {
                            _ratings[_projetIndex].ratings.push({rating})
                        }
                    })
                }
            })
            console.log("_ratings");
            console.log(_ratings);
            setRatings(_ratings)
        }).catch((error) => {
            console.log(error);
        });
    }, [event])

    //update projet status final
    function updateProjetStatusFinal(participationId, projetId, status){
        api.updateProjetStatusFinal(participationId, projetId, status).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    //update projet categorie
    function updateProjetCategorie(participationId, projetId, categorie){
        api.updateProjetCategorie(participationId, projetId, categorie).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    function cumulNoteOfProj(project){
        const _ratings = ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []
        return _ratings.reduce((totalStars,rating) => totalStars + rating.rating.stars || 0,0)
    }

    function totalMentionsForProj(project){
        const _ratings = ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []
        return _ratings.reduce((total,rating) => total + ((rating.rating.Innovation_durabilité === "checked" ? 1 : 0) + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0) + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0)),0)
    }

    function filterByStatus(project){
        if(filtre === '' || (filtre === 'avalider' && !project.projet.statusFinal)){
            return true
        }
        return filtre === project.projet.statusFinal
    }

    const LauréatsForExport = () => {
        const Lauréats = allParticipations.filter(part => part.participation?.data?.projets?.find(projet => projet.statusFinal === "validé"))
        return Lauréats.map(part => {
            return {
                ...part,
                participation: {
                    ...part.participation,
                    data: {
                        ...part.participation.data,
                        projets: part.participation.data.projets.filter(projet => projet.statusFinal === "validé")
                    }
                }
            }
        })
    }

    return (
        <div>
            {event ?
                <div>
                    <Link to="/admin/events"><button>← Retour aux événements</button></Link><br/><br/>
                    <h1>{event.title_fr}</h1>
                    <h2>Synthèse des votes du jury</h2>
                    <br/>
                    <div style={{textAlign:"right"}}>
                        <button onClick={() => exportCSVFDCandidats(LauréatsForExport(),"lauréats.csv")}>Export des lauréats</button><br/><br/>
                        <button onClick={() => exportCSVFDJurys(ratings,allJuries,allProjects,"jury.csv")}>Export des notes et commentaires des jurys</button><br/><br/>
                    </div>
                    <br/>
                    <div className='flexinfos numbers'>
                        <b>{allParticipations.filter(part => part.participation?.data?.projets?.find(projet => projet.status === "validé")).length}</b>
                        <b>{allProjects.length}</b>
                        <b>{allProjects.filter(proj => proj.projet.title && proj.projet.statusFinal === "refusé").length}</b>
                        <b>{allProjects.filter(proj => proj.projet.title && proj.projet.statusFinal !== "validé" && proj.projet.statusFinal !== "refusé").length}</b>
                        <b>{allProjects.filter(proj => proj.projet.statusFinal === "validé").length}</b>
                    </div>
                    <div className='flexinfos'>
                        <p>Candidats sélectionnés</p>
                        <p>Projets sélectionnés</p>
                        <p>Projets<br/>refusés</p>
                        <p>Projets<br/>à valider</p>
                        <p>Lauréats</p>
                    </div>
                    <br/>
                    <div>
                        <p>
                            <span>Tri : </span>
                            <select onChange={e => setTri(e.target.value)}>
                                <option value='note_et_mention'>Par cumul des notes et cumul des mentions</option>
                                <option value=''>Par catégorie</option>
                                <option value='note'>Par cumul des notes</option>
                                <option value='mention'>Par cumul des mentions</option>
                            </select>
                        </p>
                        <p>
                            <span>Filtre : </span>
                            <select onChange={e => setFiltre(e.target.value)}>
                                <option value=''>Tous</option>
                                <option value='avalider'>À valider</option>
                                <option value='validé'>Validés</option>
                                <option value='refusé'>Refusés</option>
                            </select>
                        </p>
                    </div>
                    <TableHeader>
                        <span>Cumul des notes</span>
                        <span style={{left:"40px"}}>Coup de Coeur</span>
                        <span style={{left:"80px"}}>Art de vivre à la française</span>
                        <span style={{left:"120px"}}>Innovation / Durabilité</span>
                        <span style={{left:"160px"}}>Cumul des mentions</span>
                    </TableHeader>
                    {tri === 'note_et_mention' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => totalMentionsForProj(b) - totalMentionsForProj(a)).sort((a,b) => cumulNoteOfProj(b) - cumulNoteOfProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === 'note' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => cumulNoteOfProj(b) - cumulNoteOfProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === 'mention' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => totalMentionsForProj(b) - totalMentionsForProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === '' && <>
                        {FDCategories.filter(cat => allProjects.filter(filterByStatus).filter(proj => proj.projet.categorie === cat).length > 0).map((cat,i) => 
                            <div key={i}>
                                <div className='thin' style={{backgroundColor:"#eeeeee",position:"sticky",top:"0",zIndex:"1"}}>{cat}</div>
                                {allProjects.filter(filterByStatus).filter(proj => proj.projet.categorie === cat).map((project,j) =>
                                    <CompilationLine
                                        key={j}
                                        project={project}
                                        ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                        updateProjetStatusFinal={updateProjetStatusFinal}
                                        updateProjetCategorie={updateProjetCategorie}
                                    />
                                )}
                            </div>
                        )}
                        {allProjects.filter(filterByStatus).filter(proj => !proj.projet.categorie).length > 0 &&
                            <div>
                                <div className='thin' style={{backgroundColor:"#eeeeee"}}>Pas de catégorie attribuée</div>
                                {allProjects.filter(filterByStatus).filter(proj => !proj.projet.categorie).map((project,j) =>
                                    <CompilationLine
                                        key={j}
                                        project={project}
                                        ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                        updateProjetStatusFinal={updateProjetStatusFinal}
                                        updateProjetCategorie={updateProjetCategorie}
                                    />
                                )}
                            </div>
                        }
                    </>}
                </div>
            :
                <Spinner />
            }
        </div>
    );
};

export default FDCompilationJury;